<template v-if="href">
  <a-link-v2 :url="href" :class="[name, `${name}__link`, { over: active }]">
    <grid
      :class="[`${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :class="[`${name}__grid-item`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 1, width: 24 },
        ]"
      >
        <transition name="fade">
          <a-image-v2
            v-if="(cms.image || {}).filename"
            :src="cms.image.filename"
            :alt="cms.image.alt"
            :layout="layout"
            :class="`${name}__image img_transition`"
          />
        </transition>
        <div :class="`${name}__content`">
          <a-heading
            v-if="cms.heading"
            html-tag="h2"
            :cms="cms"
            :class="`${name}__heading`"
          />
          <a-eyebrow
            v-if="cms.eyebrow"
            :cms="cms"
            :class="`${name}__eyebrow`"
          />
          <!-- eslint-disable vue/no-v-html -->
          <div
            v-if="cms.copy"
            :class="`${name}__text`"
            v-html="$options.filters.markdown(cms.copy)"
          />
          <!--eslint-enable-->
          <div v-if="cms.tags" :class="`${name}__tags`">
            <div v-for="(pill, index) in cms.tags.split(',')" :key="index">
              {{ pill }}
            </div>
          </div>

          <component
            :is="item.component"
            v-for="item in cms.cta"
            :key="item._uid"
            v-editable="item"
            :cms="{
              ...item,
              href: { url: href },
            }"
            :class="`${name}__cta`"
          />
        </div>
      </grid-item>
    </grid>
  </a-link-v2>
</template>

<script>
import data from '~/components/molecules/m-cards/m-card-narrow.data'
import ACtaV2 from '~/components/atoms/a-ctas/a-cta-v2'

export default {
  components: { ACtaV2 },
  props: {
    cms: {
      type: Object,
      default() {
        return Object.assign(process.env.NODE_ENV === 'development' ? data : {})
      },
    },
    url: {
      type: String,
      default() {
        return null
      },
    },
    layout: {
      type: Array,
      default() {
        return [{ size: 0, bound: 313, ratio: [315, 212] }]
      },
    },
  },
  data() {
    return {
      name: 'm-card-wide',
      active: false,
    }
  },
  computed: {
    href() {
      return (
        this.url ||
        (this.cms.href || {}).url ||
        (this.cms.href || {}).cached_url
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.m-card-wide {
  overflow: hidden;

  ::v-deep img {
    aspect-ratio: 4 / 3;
    object-fit: cover;
    transition: all 0.5s ease;
  }

  &__eyebrow {
    margin-top: 8px;
    font-size: 16px;
    font-weight: 700;
    line-height: 125%; /* 20px */
  }

  &__heading {
    font-family: 'NeueHaasGroteskText', Helvetica, Arial, sans-serif;
    font-size: 28px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%; /* 35px */
    letter-spacing: 1px;
    margin-top: 16px;
    margin-bottom: 0;
  }

  &__tags {
    color: #576a75;

    /* XS - 12/Regular */
    font-family: 'NeueHaasGroteskText', Helvetica, Arial, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%; /* 15px */
    display: flex;
    flex-direction: row;
    gap: 8px;
    margin-top: 32px;
  }

  &__text {
    ::v-deep p {
      font-size: 12px !important;
    }
  }
}
</style>
